/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo － 出会って、チャットして、友達の輪を広げよう",
      "電話番号が間違っています",
      "Get the app",
      "Appleでログイン",
      "Facebookで続ける",
      "Googleで続ける",
      "ログイン",
      "登録する",
      "続けるには、表示されている文字を入力してください",
      "続ける",
      "文字を入力",
      "セキュリティチェック",
      "再読み込み",
      "簡単に覚えられる新しいパスワードを作成：",
      "アップデート",
      "パスワードを確定",
      "パスワードは{{num}}[[characters:num]]以上で設定してください",
      "パスワード",
      "新しいパスワードを作る",
      "Badoo ー The Blog",
      "採用情報",
      "チャット",
      "都市",
      "クッキーの管理",
      "著作権 © 2006 – 現在。Bumble（不許複製・禁無断転載）",
      "AppleおよびAppleのロゴはApple Inc.の商標です。{{__EOL__}}Google PlayはGoogle LLCの商標です。",
      "ダウンロード",
      "Facebook",
      "フォローはこちらから",
      "ヘルプセンター",
      "Instagram",
      "言語",
      "LinkedIn",
      "概要",
      "BadooはBumble Incの一部です。",
      "プライバシーポリシー",
      "Safety Centre",
      "サイトマップ",
      "現代奴隷法",
      "利用規約",
      "Twitter",
      "メールアドレスまたは携帯電話番号を入力してください。新しいパスワードの設定方法をお送りいたします。",
      "新しいパスワードを取得する",
      "メールアドレスまたは携帯番号を入力",
      "パスワードを忘れた",
      "モデルはイメージです。",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "マッチングの成立を待つ必要はありません。{{__EOL__}}{{__EOL__}}もう少し深いおしゃべりをして、お相手に寄り添ってみましょう。これでお互いを本当に知ることができます。",
      "チャットへの心の準備は整っていますか？",
      "ご登録いただくと、当社の <a class=\"link\" href=\"{{terms_url}}\">利用規約に同意したとみなされます</a>。<br/>情報の取り扱いに関する詳細については <a class=\"link\" href=\"{{privacy_url}}\">プライバシーポリシーをご覧ください。</a>",
      "本当の自分をもっと出して、<br />心地のいいデートができるように。",
      "自信を持ってデートをするために",
      "または",
      "アカウントをお持ちですか？",
      "メールアドレスまたは電話番号で登録",
      "デートをして願いを叶えましょう。{{__EOL__}}謝る必要はありません。",
      "ただおしゃべりしたい？大丈夫です。{{__EOL__}}落ち着きたい？それもいい。{{__EOL__}}{{__EOL__}}今後もし気が変わったとしても、絶対に大丈夫。",
      "気軽な交際",
      "真剣な交際",
      "気軽な会話",
      "同じ想いを持つ人々と出会う。",
      "{{name}}さん，{{age}}",
      "あなたの安全が第一です。",
      "私たちのセーフティセンターは、ユーザーの安心・安全だけでなく自信を持ってデートするための、あらゆるサポートを提供しています。",
      "私たちのセーフティセンターを確認する",
      "1に安全、2に安全。<br/>いつでも安全が第一。",
      "最初の瞬間から、うまくいくと思ってた…",
      "「最初は真剣な交際すら考えていなかった...」",
      "Badooを使う方へのアドバイスをひとつ。ありのままの自分でいること…",
      "Badooのサクセスストーリー",
      "サクセスストーリーをもっと見る",
      "{{num}}__CUT__レート",
      "Apple App Store",
      "私たちを信じてください。2006年以来、私たちは何百万人（それ以上）の人々をめぐりあわせてきました。",
      "{{num}}00万回以上__CUT__ダウンロード",
      "{{num}}00万＋",
      "Google Play Store",
      "しっかりとわかっているので任せてください。",
      "メールアドレスまたは電話番号で登録",
      "パスワードを入力して下さい",
      "パスワードをお忘れですか？",
      "登録",
      "アカウントがありませんか？",
      "ログイン",
      "登録"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "文字"
            ],
            "singular": [
                  "文字"
            ]
      },
      "day": {
            "plural": [
                  "日"
            ],
            "singular": [
                  "日"
            ]
      },
      "hour": {
            "plural": [
                  "時間"
            ],
            "singular": [
                  "時間"
            ]
      },
      "minute": {
            "plural": [
                  "分"
            ],
            "singular": [
                  "分"
            ]
      },
      "month": {
            "plural": [
                  "ヶ月"
            ],
            "singular": [
                  "ヶ月"
            ]
      },
      "second": {
            "plural": [
                  "秒"
            ],
            "singular": [
                  "秒"
            ]
      },
      "year": {
            "plural": [
                  "年"
            ],
            "singular": [
                  "年"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
